import { useEffect, useState } from "react";

const useLoadQSs = (axiosPrivate, reloadlistdata, navigate, location, url, limit) => {
  const [listdata, setListdata] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    const getQSList = async () => {
      try {
        const response = await axiosPrivate.get(`/api/qs/${url}?limit=${limit}`);
        if (response.data.message !== "No positions exist.") {
          setListdata(response.data);
        }
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getQSList();
    return () => controller.abort();
  }, [reloadlistdata, limit]);

  return listdata;
};

export default useLoadQSs;
